import { useCallback } from 'react';
import { GrouperView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Hook for handling base rates grid row selection
 */
export function useBaseRatesSelection(
  groupers: GrouperView[],
  onEdit: (grouper: GrouperView) => void
) {
  const handleRowSelection = useCallback(
    (args: { data?: { id: string } }) => {
      if (args.data) {
        const selectedGrouper = groupers.find((g) => g.id === args.data!.id);
        if (selectedGrouper) {
          onEdit(selectedGrouper);
        }
      }
    },
    [groupers, onEdit]
  );

  return {
    handleRowSelection,
  };
}
